import { type IPropertyValue } from '@mahawi/eshop-common/src/types';
import { type RootState } from '@reducers';
import { Divider, Pagination, Space } from 'antd';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { SPACING } from '../../theme/tokens';
import BubbleComponent from '../bubble';
import ValueName from './value-name';

function PropertyValue(): React.ReactElement {
  const propertyValues = useSelector(
    (s: RootState) => s.Property.property?.values,
  );

  const [propertyValueEl, setPropertyValueEl] = useState<React.ReactElement[]>(
    [],
  );
  const [page, setPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);

  useEffect((): void => {
    if (!propertyValues) {
      return;
    }

    const start: number = (page - 1) * pageSize;
    const end: number = start + pageSize;

    const propertyValuesToShown: IPropertyValue[] = propertyValues.slice(
      start,
      end,
    );

    const propertyValueElUE: React.ReactElement[] = propertyValuesToShown.map(
      (propertyValue: IPropertyValue): React.ReactElement => {
        return (
          <ValueName key={propertyValue.code} propertyValue={propertyValue} />
        );
      },
    );

    setPropertyValueEl(propertyValueElUE);
  }, [propertyValues, page, pageSize]);

  return (
    <BubbleComponent span={16}>
      <Space size={SPACING.lg} align="start" orientation="horizontal">
        <strong>Value</strong>

        <Pagination
          current={page}
          total={propertyValues?.length}
          showLessItems
          showSizeChanger
          showPrevNextJumpers
          showQuickJumper
          showTitle
          showTotal={(total: number, range: [number, number]): string =>
            `${range[0]}-${range[1]} of ${total} items`
          }
          onChange={(
            paginatorPage: number,
            paginatorPageSize: number,
          ): void => {
            setPage(paginatorPage);
            setPageSize(paginatorPageSize);
          }}
        />
      </Space>

      <Divider />

      {propertyValueEl}
    </BubbleComponent>
  );
}

export default PropertyValue;
